export const featuredWorks = [
  {
    id: "f-01",
    title: "《星野物语·春》高清原图集",
    author: "星尘绘",
    tag: "画集",
    tagColor: "primary",
    pages: 128,
    price: "免费浏览",
    update: "3天前更新",
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20artbook%20cover%20of%20a%20girl%20with%20silver%20hair%20standing%20in%20a%20blooming%20cherry%20blossom%20forest%20at%20dawn%2C%20soft%20pink%20and%20warm%20gold%20light%2C%20dreamy%20atmosphere%2C%20high%20detail%20line%20art%2C%20professional%20doujin%20artbook%20style%2C%20clean%20composition%2C%20vibrant%20colors&width=800&height=1000&seq=doujin-f01&orientation=portrait",
  },
  {
    id: "f-02",
    title: "《夏日祭典·烟火》同人画集",
    author: "橘音",
    tag: "画集",
    tagColor: "accent",
    pages: 96,
    price: "免费浏览",
    update: "1周前更新",
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20two%20friends%20watching%20summer%20fireworks%20in%20yukata%20by%20the%20river%2C%20warm%20festival%20lanterns%2C%20navy%20night%20sky%20with%20colorful%20bursts%2C%20nostalgic%20summer%20mood%2C%20detailed%20doujin%20artbook%20cover%2C%20cinematic%20lighting&width=800&height=1000&seq=doujin-f02&orientation=portrait",
  },
  {
    id: "f-03",
    title: "《深海来信》原创图包·全彩",
    author: "蓝鲸鱼",
    tag: "图包",
    tagColor: "secondary",
    pages: 60,
    price: "免费浏览",
    update: "2周前更新",
    image: "https://readdy.ai/api/search-image?query=original%20anime%20illustration%20of%20a%20girl%20submerged%20in%20crystal%20blue%20ocean%20light%2C%20bubbles%20and%20a%20giant%20whale%20silhouette%2C%20ethereal%20underwater%20glow%2C%20teal%20and%20gold%20tone%2C%20artistic%20doujin%20illustration%2C%20smooth%20painting%20style&width=800&height=1000&seq=doujin-f03&orientation=portrait",
  },
  {
    id: "f-04",
    title: "《咖啡屋日常》治愈系画集",
    author: "豆芽",
    tag: "画集",
    tagColor: "primary",
    pages: 88,
    price: "免费浏览",
    update: "1月前更新",
    image: "https://readdy.ai/api/search-image?query=cozy%20anime%20illustration%20of%20a%20barista%20in%20a%20warm%20cafe%20pouring%20latte%20art%2C%20golden%20morning%20sunlight%20through%20window%2C%20scented%20steam%2C%20relaxed%20healing%20atmosphere%2C%20soft%20beige%20and%20caramel%20tones%2C%20detailed%20doujin%20artbook%20style&width=800&height=1000&seq=doujin-f04&orientation=portrait",
  },
  {
    id: "f-05",
    title: "《幻境回廊》奇幻场景图包",
    author: "雾岛",
    tag: "图包",
    tagColor: "accent",
    pages: 72,
    price: "免费浏览",
    update: "3周前更新",
    image: "https://readdy.ai/api/search-image?query=fantasy%20anime%20landscape%20illustration%20of%20a%20floating%20corridor%20between%20magical%20islands%2C%20glowing%20moss%20and%20crystals%2C%20lavender%20and%20emerald%20palette%2C%20epic%20depth%2C%20matte%20painting%20doujin%20art%2C%20rich%20detail&width=800&height=1000&seq=doujin-f05&orientation=portrait",
  },
  {
    id: "f-06",
    title: "《与你的四季》高清扫描画集",
    author: "一木",
    tag: "扫描",
    tagColor: "secondary",
    pages: 144,
    price: "免费浏览",
    update: "5天前更新",
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20collage%20of%20four%20seasons%20of%20a%20young%20girl%20under%20the%20same%20tree%2C%20cherry%20blossoms%2C%20green%20summer%2C%20golden%20autumn%2C%20snowy%20winter%2C%20soft%20watercolor%20feel%2C%20doujin%20artbook%20style%2C%20warm%20nostalgic%20tone&width=800&height=1000&seq=doujin-f06&orientation=portrait",
  },
];

export const categoryList = [
  {
    id: "cat-artbook",
    title: "高清画集",
    desc: "原图画集在线浏览",
    count: 1286,
    icon: "ri-book-2-line",
    color: "primary",
  },
  {
    id: "cat-pack",
    title: "精选图包",
    desc: "成套图包快速查看",
    count: 862,
    icon: "ri-gallery-line",
    color: "accent",
  },
  {
    id: "cat-hd",
    title: "高清原图",
    desc: "大尺寸清晰原图",
    count: 2043,
    icon: "ri-focus-3-line",
    color: "secondary",
  },
  {
    id: "cat-scan",
    title: "扫描本集",
    desc: "同人志扫描收藏",
    count: 458,
    icon: "ri-stack-line",
    color: "primary",
  },
];

export const galleryWorks = [
  {
    id: "g-01",
    title: "《星夜列车》高清原图",
    author: "未眠",
    cat: "高清原图",
    views: "12.8万",
    likes: "8.2万",
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20night%20train%20traveling%20through%20a%20starry%20sky%20over%20neon%20city%2C%20window%20seat%20girl%20looking%20out%2C%20deep%20blue%20and%20warm%20amber%20lights%2C%20dreamy%20doujin%20style%2C%20high%20detail&width=800&height=1000&seq=doujin-g01&orientation=portrait",
  },
  {
    id: "g-02",
    title: "《花与少年》画集内页",
    author: "白露",
    cat: "高清画集",
    views: "9.6万",
    likes: "6.1万",
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20boy%20with%20dark%20hair%20holding%20a%20single%20white%20flower%2C%20soft%20morning%20garden%20light%2C%20gentle%20pastel%20tones%2C%20doujin%20artbook%20interior%2C%20clean%20and%20elegant&width=800&height=1000&seq=doujin-g02&orientation=portrait",
  },
  {
    id: "g-03",
    title: "《蒸汽朋克城》场景图包",
    author: "齿轮",
    cat: "精选图包",
    views: "15.2万",
    likes: "9.9万",
    image: "https://readdy.ai/api/search-image?query=steampunk%20anime%20cityscape%20illustration%20with%20airships%20and%20gears%2C%20copper%20and%20brass%20tones%2C%20golden%20haze%2C%20detailed%20machinery%2C%20doujin%20art%20style%2C%20epic%20perspective&width=800&height=1000&seq=doujin-g03&orientation=portrait",
  },
  {
    id: "g-04",
    title: "《山海志怪录》扫描页",
    author: "青鸾",
    cat: "扫描本集",
    views: "7.4万",
    likes: "4.8万",
    image: "https://readdy.ai/api/search-image?query=ancient%20chinese%20mythical%20beast%20anime%20illustration%2C%20fox%20spirit%20with%20nine%20tails%20in%20ink%20wash%20style%2C%20cinnabar%20red%20and%20ink%20black%2C%20traditional%20atmosphere%2C%20doujin%20artbook%20scan%20style&width=800&height=1000&seq=doujin-g04&orientation=portrait",
  },
  {
    id: "g-05",
    title: "《盛夏蝉鸣》清新原图",
    author: "蝉鸣",
    cat: "高清原图",
    views: "11.3万",
    likes: "7.6万",
    image: "https://readdy.ai/api/search-image?query=summer%20anime%20illustration%20of%20a%20girl%20on%20a%20bicycle%20under%20green%20tree%20shadows%2C%20sunlight%20dapples%2C%20sweat%20and%20smile%2C%20fresh%20green%20and%20white%20tone%2C%20doujin%20style%2C%20bright%20and%20clear&width=800&height=1000&seq=doujin-g05&orientation=portrait",
  },
  {
    id: "g-06",
    title: "《机械之心》画集彩页",
    author: "齿轮",
    cat: "高清画集",
    views: "10.1万",
    likes: "6.9万",
    image: "https://readdy.ai/api/search-image?query=anime%20girl%20mecha%20pilot%20illustration%20in%20a%20hangar%2C%20blue%20and%20orange%20contrast%20lighting%2C%20glowing%20cores%2C%20sci-fi%20doujin%20artbook%20page%2C%20mechanical%20detail%2C%20dynamic%20pose&width=800&height=1000&seq=doujin-g06&orientation=portrait",
  },
  {
    id: "g-07",
    title: "《猫与猫的午后》图包",
    author: "豆芽",
    cat: "精选图包",
    views: "8.8万",
    likes: "5.5万",
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20girl%20napping%20with%20two%20cats%20on%20a%20sunny%20windowsill%2C%20warm%20afternoon%20light%2C%20soft%20cream%20and%20peach%20tones%2C%20cozy%20doujin%20style%2C%20gentle%20and%20healing&width=800&height=1000&seq=doujin-g07&orientation=portrait",
  },
  {
    id: "g-08",
    title: "《云端书店》奇幻画集",
    author: "雾岛",
    cat: "高清画集",
    views: "13.5万",
    likes: "8.8万",
    image: "https://readdy.ai/api/search-image?query=fantasy%20anime%20illustration%20of%20a%20floating%20bookstore%20in%20the%20clouds%2C%20a%20girl%20reading%20on%20a%20ladder%2C%20golden%20sunset%20clouds%2C%20dreamy%20whimsical%2C%20doujin%20artbook%20style%2C%20rich%20detail&width=800&height=1000&seq=doujin-g08&orientation=portrait",
  },
  {
    id: "g-09",
    title: "《夜巡·雨巷》扫描收藏",
    author: "未眠",
    cat: "扫描本集",
    views: "6.9万",
    likes: "4.2万",
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20girl%20with%20umbrella%20walking%20a%20rainy%20laneway%20at%20night%2C%20street%20lamp%20reflections%2C%20teal%20and%20warm%20light%2C%20melancholic%20doujin%20style%2C%20atmospheric&width=800&height=1000&seq=doujin-g09&orientation=portrait",
  },
  {
    id: "g-10",
    title: "《甜品星球》甜系图包",
    author: "糖霜",
    cat: "精选图包",
    views: "9.2万",
    likes: "6.4万",
    image: "https://readdy.ai/api/search-image?query=cute%20anime%20illustration%20of%20dessert%20planet%20with%20cake%20mountains%20and%20candy%20rain%2C%20a%20girl%20floating%20in%20space%2C%20pastel%20pink%20and%20cream%2C%20kawaii%20doujin%20style%2C%20playful%20and%20colorful&width=800&height=1000&seq=doujin-g10&orientation=portrait",
  },
  {
    id: "g-11",
    title: "《独白》黑白线稿集",
    author: "一木",
    cat: "高清原图",
    views: "5.8万",
    likes: "3.9万",
    image: "https://readdy.ai/api/search-image?query=black%20and%20white%20anime%20line%20art%20illustration%20of%20a%20girl%20profile%20with%20flowing%20hair%2C%20cross%20hatching%2C%20ink%20sketch%20doujin%20style%2C%20expressive%20detailed%20lines%2C%20minimalist%20background&width=800&height=1000&seq=doujin-g11&orientation=portrait",
  },
  {
    id: "g-12",
    title: "《萤火之森》夏夜画集",
    author: "星尘绘",
    cat: "高清画集",
    views: "14.7万",
    likes: "10.2万",
    image: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20forest%20glade%20full%20of%20fireflies%20at%20night%2C%20a%20boy%20and%20girl%20standing%20apart%2C%20emerald%20and%20gold%20glow%2C%20magical%20doujin%20artbook%20style%2C%20dreamy%20and%20warm&width=800&height=1000&seq=doujin-g12&orientation=portrait",
  },
];

export const newsList = [
  {
    id: "n-01",
    date: "2026-08-14",
    title: "《星野物语·夏》高清原图集正式上线，首批 128 页全彩放送",
    tag: "新本发布",
  },
  {
    id: "n-02",
    date: "2026-08-10",
    title: "本周精选图包更新：《蒸汽朋克城》场景包已开放高清浏览",
    tag: "图包更新",
  },
  {
    id: "n-03",
    date: "2026-08-06",
    title: "分类大整理：新增「扫描本集」专区，收藏同人志更方便",
    tag: "功能优化",
  },
  {
    id: "n-04",
    date: "2026-08-02",
    title: "在线浏览体验升级：画集支持翻页预览与高清缩放查看",
    tag: "体验优化",
  },
  {
    id: "n-05",
    date: "2026-07-28",
    title: "夏日专题企划开启，热门作品高清原图陆续放送",
    tag: "专题活动",
  },
];

export const faqList = [
  {
    id: "faq-01",
    question: "在线浏览是否需要注册账号？",
    answer:
      "目前站内所有画集、图包与高清原图均支持免费在线浏览，无需注册即可欣赏。若后续开放收藏与下载记录功能，将另行说明账号体系安排。",
  },
  {
    id: "faq-02",
    question: "高清原图与原图集有什么区别？",
    answer:
      "高清原图指单张的大尺寸清晰图片，适合查看细节与收藏参考；原图集则是成册的画集，把同一作品的多张页面整合在一起，方便连贯阅读和批量浏览。",
  },
  {
    id: "faq-03",
    question: "图包内的作品风格是否统一？",
    answer:
      "是的。每个图包都围绕同一主题或同一作者整理，画风与配色保持一致，方便成套收藏与参考，避免风格混杂。",
  },
  {
    id: "faq-04",
    question: "更新频率大概是多久一次？",
    answer:
      "网站保持较高更新频率，热门画集与图包会持续放送，新的高清原图通常每周批量上线，可在首页「更新资讯」查看最新动态。",
  },
  {
    id: "faq-05",
    question: "作品是否支持批量下载？",
    answer:
      "在线浏览支持高清查看与批量预览，批量下载功能正在规划中，后续将结合账号体系一并开放，敬请期待。",
  },
];

export const testimonials = [
  {
    id: "t-01",
    name: "插画爱好者·小禾",
    role: "收藏玩家",
    text: "分类很细，找参考图特别方便，画质是真的清晰，放大看细节也完全不打折扣。",
  },
  {
    id: "t-02",
    name: "自由画师·阿凯",
    role: "参考学习",
    text: "同人本子更新快，题材覆盖广，拿来当光影和构图的参考非常实用。",
  },
  {
    id: "t-03",
    name: "动漫同好·柚子",
    role: "社区用户",
    text: "在线浏览体验很顺，翻页流畅，夏日祭那套画集我反复看了好多遍，太喜欢了。",
  },
];